import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";


const pageTitle = "About TAP Persia";

export default class About extends Component {


    render() {

        return (
            <div >
                <div className="jumbotron text-center rtl">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right">
                            <h1 className="pag-title">{pageTitle}</h1>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                                {/*<BreadcrumbItem><a href="#">محصولات</a></BreadcrumbItem>*/}
                                <BreadcrumbItem active>{pageTitle}</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl">
                    <div className="row">

                        <div className="col-sm-12" style={{ minHeight: 500 }}>
                            <h3>{pageTitle}</h3>
                            <p className="text-justify">
                                Safe travels, unsurpassed experiences and a lifetime of memories. That is our purpose, that is our mission. As a group of young travellers, adventurers, writers and artists, our goal is quite simple: to welcome foreign guests to the heart of Iran and make them feel at home. We pride ourselves deeply on our customer service. Our team works every day to make sure your travel and stay in Iran is as effortless as possible.
                            </p>
                            <p className="text-justify">
                                Feel free to contact us with any questions you may have about our website and services.
                            </p>
                            <p className="text-justify">
                                It is our pleasure, and indeed privilege, to welcome you to the beautiful land of hospitality.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


}



// WEBPACK FOOTER //
// ./src/containers/about/About.js